// React
import React from 'react'

// Components
import { ModalCartPicker } from 'store/modules/cart/CartPicker/Modal'

// Hooks
import { useDatePicker } from 'store/hooks/useDatePicker'

export const CartPicker = () => {
  const { isOpen, close } = useDatePicker()

  return <ModalCartPicker open={isOpen} onClose={close} />
}
